export default __webpack_public_path__ + "static/media/Giacomo_Tenaglia.752d9f9a.jpeg";